module.exports = __webpack_public_path__ + "media/images/screens/07_detailsProduits-fe1ad5b2845efb2cf79dbab1aecc5c3f.jpg";